module.exports = __webpack_public_path__ + "img/Path 518.71fb2634.svg";